export const KnownObisCodes = {
  NotApplicable: 'N/A',
  DefaultGasObis: '7-3.0.0',
};
